// extracted by mini-css-extract-plugin
module.exports = {"title-default":"Title_title-default__9fb4_","title-small":"Title_title-small__fFc_w"};